export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
export const REVERSED_DEFAULT_DATE_FORMAT = 'dd-MM-yyyy';
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const DATE_TIME_FORMAT_NO_SEC = 'yyyy-MM-dd HH:mm';
export const DATE_TIME_FORMAT_DOTS_SEPARATOR = 'dd.MM.yyyy HH:mm';
export const FULL_DATE = "yyyy-MM-dd'T'HH:mm:ssXXX";
export const DOW_AND_MONTH_FORMAT = 'E. d MMM';
export const CALENDAR_DATE_FORMAT = 'dd MMMM yyyy';
export const DAY_OF_WEEK_ONLY = 'eeee';
